// extracted by mini-css-extract-plugin
export default {"fullscreen-modal":"FullscreenModal_fullscreen-modal__AP1I4","container":"FullscreenModal_container__DYkeA"};